exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Column___5Ol48 {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 0 1rem;\n}\n\n.Header___322Sm {\n  font-size: var(--font-size-sans-large);\n  margin-bottom: 0.5rem;\n}\n\n.Paragraph___22fN5 {\n  text-align: center;\n  margin: 0;\n}\n\n.Link___36nzP {\n  color: var(--color-link);\n}\n\n.LearnMoreRow___aWp1e {\n  margin-top: 1rem;\n  color: var(--color-dim);\n  font-size: var(--font-size-sans-small);\n}\n\n.Code___19uUo {\n  color: var(--color-bridge-version-number);\n}\n\n.MetaGKRow___1tKC1 {\n  background: var(--color-background-hover);\n  padding: 0.25rem 0.5rem;\n  border-radius: 0.25rem;\n  margin-top: 1rem;\n}", ""]);

// exports
exports.locals = {
	"Column": "Column___5Ol48",
	"Header": "Header___322Sm",
	"Paragraph": "Paragraph___22fN5",
	"Link": "Link___36nzP",
	"LearnMoreRow": "LearnMoreRow___aWp1e",
	"Code": "Code___19uUo",
	"MetaGKRow": "MetaGKRow___1tKC1"
};